import { render, staticRenderFns } from "./oridebaman.vue?vue&type=template&id=96b6a0e4&scoped=true&"
import script from "./oridebaman.vue?vue&type=script&lang=js&"
export * from "./oridebaman.vue?vue&type=script&lang=js&"
import style0 from "./oridebaman.vue?vue&type=style&index=0&id=96b6a0e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b6a0e4",
  null
  
)

export default component.exports